import {CheckCircle2, AlertTriangle} from 'lucide-react';
import {Card, CardContent, CardHeader, CardTitle} from '@common-web/components/ui/card';
import {Button} from '@common-web/components/ui/button';

type DuplicateCheckStepProps = {
  duplicates: {indices: number[]; key: string}[];
  onBack: () => void;
  onContinue: () => void;
};

export function DuplicateCheckStep({duplicates, onBack, onContinue}: DuplicateCheckStepProps) {
  return (
    <Card className='border-0 shadow-lg bg-white overflow-hidden'>
      <CardHeader className='bg-gradient-to-r from-gray-50 to-white border-b border-gray-100 px-6 py-4'>
        <CardTitle className='text-lg font-semibold text-brand-navy'>
          Step 3: Duplicate Check
        </CardTitle>
      </CardHeader>
      <CardContent className='p-6'>
        {duplicates.length === 0 ? (
          <div className='flex items-center gap-2 p-3 rounded-lg bg-emerald-50'>
            <CheckCircle2 className='h-5 w-5 text-emerald-600' />
            <span className='text-sm text-emerald-700 font-medium'>
              No duplicates found in this file.
            </span>
          </div>
        ) : (
          <div className='space-y-3'>
            <div className='flex items-center gap-2 p-3 rounded-lg bg-amber-50'>
              <AlertTriangle className='h-5 w-5 text-amber-600' />
              <span className='text-sm text-amber-700 font-medium'>
                {duplicates.length} potential duplicate
                {duplicates.length !== 1 ? 's' : ''} found (by SSN).
              </span>
            </div>
            <div className='space-y-2'>
              {duplicates.map((d) => (
                <div
                  key={d.key}
                  className='flex items-center gap-3 p-3 rounded-lg border border-amber-200 bg-amber-50/50 text-sm'
                >
                  <span className='text-gray-500 font-mono'>SSN …{d.key.slice(-4)}</span>
                  <span className='text-gray-400'>→</span>
                  <span className='text-amber-800'>Rows {d.indices.join(', ')}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className='flex items-center justify-between mt-6 pt-4 border-t border-gray-100'>
          <Button variant='outline' onClick={onBack}>
            Back
          </Button>
          <Button onClick={onContinue}>Continue</Button>
        </div>
      </CardContent>
    </Card>
  );
}
